import { Inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environment/environment';
import { IAppConfig } from '@app/app-config';
import { DOCUMENT } from '@angular/common';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: "root",
})
export class AppConfig {
    static settings: IAppConfig;
    constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document, private handler: HttpBackend) { }
       
    /*
    load() {
        const jsonFile = `${environment.configuracion}.json`;
        const urlActual = this.document.location.href.split("#")[0];
        return new Promise<void>((resolve, reject) => {
            
            lastValueFrom(this.http.get(jsonFile)).then((response: any) => {
                
                const data: any[] = response;
                const cliente: any = data.filter(datos => urlActual.includes(datos.sitio));

                AppConfig.settings = cliente[0] as IAppConfig;
                resolve();
            }).catch((response: any) => {
                reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
        */
    
    
    load() {
        
        const urlActual = this.document.location.href.split("#")[0];
        
        const paramsHeaders = {
            'Content-Type': 'application/json',
            'Client':'desarrollo',
            'dbname':'Clients',
            'collection':'json',
            'bd_secundario':'desarrollo'
        };
        
        const paramsService = {
            sitio: urlActual
        }

        return new Promise<void>((resolve, reject) => {
            
            fetch(environment.apiUrl + 'Clients/', {
                method: 'POST',
                body: JSON.stringify(paramsService),
                headers: paramsHeaders
            })
            .then(response => response.json())
            .then(responseData => {
                AppConfig.settings = responseData[0] as IAppConfig;
                resolve();
            })
            .catch(error => {
                console.error('Error al hacer la solicitud:', error);
                reject(`Could not load client: ${error}`);
            });
        });
    }
    
}
